import React, { useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Style from './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel, Keyboard } from 'swiper';
import People from '@src/pc/index/layout/Page1/People';
import Chip from 'Chip';

const Page1 = (props) => {
    const { peopleList, onChangeMaskVisible, onChangeCurrentVideo, onChangeFloat, config, peopleIndex, setPeopleIndex, slideIndex } = props;
    const [isShowHUD, setIsShowHUD] = useState(true);

    const swiperRef = useRef();
    const slideIndexRef = useRef(slideIndex);
    const lightRef = useRef();

    const changePeopleAndSwiper = (index) => {
        setPeopleIndex(index);
        // eslint-disable-next-line no-unused-expressions
        swiperRef.current?.slideTo(index);
    };

    const toPrev = () => {
        if (peopleIndex) {
            changePeopleAndSwiper(peopleIndex - 1);
        }
    };

    const toNext = () => {
        if (peopleIndex < peopleList.length - 1) {
            changePeopleAndSwiper(peopleIndex + 1);
        }
    };

    const swiperChange = (swiper) => {
        setPeopleIndex(swiper.realIndex);
    };

    useEffect(() => {
        // console.log('change------', slideIndex, slideIndexRef.current, slideIndex == 2);
        if (peopleIndex > -1) {
            if (slideIndexRef.current !== '2' && slideIndex === '2') {
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(peopleIndex, 0);
            } else if (slideIndex === '2') {
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(peopleIndex);
                // console.log('slide-----');
            } else {
                // eslint-disable-next-line no-unused-expressions
                swiperRef.current?.slideTo(peopleIndex, 0);
            }
            slideIndexRef.current = slideIndex;
        }
    }, [peopleIndex, slideIndex]);

    return (
        <div className={Style.page1}>
            <Swiper
                initialSlide={peopleIndex > -1 ? peopleIndex : peopleIndex + 1}
                modules={[Navigation, Mousewheel, Keyboard]}
                className={Style.swiper}
                speed={1500}
                mousewheel={{
                    forceToAxis: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                onSlideChange={swiperChange}>
                {config.find((a) => a.id === 'peopleList').isShow &&
                    peopleList.map((people, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <People people={people} onChangeMaskVisible={onChangeMaskVisible} onChangeCurrentVideo={onChangeCurrentVideo} />
                            </SwiperSlide>
                        );
                    })}
            </Swiper>
            {config.find((a) => a.id === 'peopleList').isShow && isShowHUD && (
                <>
                    <img
                        className={`${Style.navigation} ${Style.prev} ${peopleIndex > 0 ? '' : Style.hide}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'prev' : 'prev2'}.png`)}
                        alt=""
                        onClick={toPrev}
                    />
                    <img
                        className={`${Style.navigation} ${Style.next} ${peopleIndex === 0 ? Style.animate : ''}`}
                        src={require(`@src/common/assets/${peopleIndex > -1 ? 'next' : 'next2'}.png`)}
                        alt=""
                        onClick={toNext}
                    />
                </>
            )}
        </div>
    );
};

Page1.propTypes = {
    peopleList: PropTypes.array,
    config: PropTypes.array,
    onChangeMaskVisible: PropTypes.func,
    onChangeCurrentVideo: PropTypes.func,
    onChangeFloat: PropTypes.func,
    peopleIndex: PropTypes.number,
    setPeopleIndex: PropTypes.func,
    slideIndex: PropTypes.number,
};

export default errorBoundary(Page1);
